// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const aggron_mega: PokeData = {
  "id": 10053,
  "name": "aggron-mega",
  "height": 22,
  "weight": 3950,
  "base_experience": 284,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "roar",
    "harden",
    "rock-slide",
    "protect",
    "mud-slap",
    "iron-tail",
    "metal-claw",
    "rock-tomb",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "iron-head",
    "autotomize",
    "heavy-slam"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "rock-slide",
    "protect",
    "mud-slap",
    "metal-claw",
    "rock-tomb",
    "metal-sound",
    "metal-burst",
    "steel-beam",
    "gear-up",
    "metal-rush",
    "scrap-throw"
  ],
  "evolution_chain": {
    "id": 151,
    "item": null,
    "species": [
      {
        "name": "aron",
        "order": 330,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lairon",
        "order": 331,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 304,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "aggron",
        "order": 332,
        "types": [
          PokeType.STEEL,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 305,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 149,
    "speed": 66,
    "ability_power": 185
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
